"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var getByteLength_1 = require("../helpers/getByteLength");
var api_1 = require("@opentelemetry/api");
var isBrowser = typeof window !== 'undefined';
if (isBrowser) {
    // eslint-disable-next-line global-require
    require('abortcontroller-polyfill');
}
var Fetch = /** @class */ (function () {
    function Fetch(url, options) {
        if (url === void 0) { url = '/'; }
        if (options === void 0) { options = {}; }
        options.headers = new Headers(options.headers);
        if (!options.headers.get('Content-Type')) {
            options.headers.append('Content-Type', 'application/json');
        }
        this.options = {
            method: options.method || 'POST',
            headers: options.headers,
            credentials: options.credentials || 'include',
        };
        this.url = url;
        this.otelPropagation = options.otelPropagation || false;
    }
    /**
     * Send request to server
     */
    Fetch.prototype.call = function (request, options) {
        this.addMethodHeader(request);
        this.addOTelContextPropagationHeader(request);
        return fetch(this.url, __assign(__assign(__assign({ body: JSON.stringify(request) }, options), this.options), { 'Content-Length': (0, getByteLength_1.getByteLength)(JSON.stringify(request)).toString(10) }))
            .then(function (data) { return data.json(); });
    };
    Fetch.prototype.addOTelContextPropagationHeader = function (request) {
        var _a, _b;
        if (!this.otelPropagation) {
            return this;
        }
        api_1.propagation.inject(api_1.context.active(), (_a = request === null || request === void 0 ? void 0 : request.params) === null || _a === void 0 ? void 0 : _a.headers);
        var key = 'traceparent';
        var requestHeaders = new Headers((_b = request === null || request === void 0 ? void 0 : request.params) === null || _b === void 0 ? void 0 : _b.headers);
        var traceparent = requestHeaders.get(key);
        if (traceparent) {
            var headers = new Headers(this.options.headers);
            headers.set(key, traceparent);
            this.options.headers = headers;
        }
        return this;
    };
    /**
     * Adds method header for logging purposes
     */
    Fetch.prototype.addMethodHeader = function (request) {
        var headers = new Headers(this.options.headers);
        if (!Array.isArray(request)) {
            headers.set('X-JsonRpc-Method', request.method);
        }
        else {
            headers.set('X-JsonRpc-Method', request.reduce(function (acc, request) { return acc.push(request.method); }, [])
                .join(','));
        }
        this.options.headers = headers;
        return this;
    };
    return Fetch;
}());
exports.default = Fetch;
//# sourceMappingURL=Fetch.js.map